export default {
    tipo: "",
    detalhamento: "",
    justificativa: "",
    valor: 0,
    mes: 0,
    quantidade: 0
}
